import { DocumentoLegal, LegalTipo } from "./tipos";

/** Compara versões "x.y.z" numericamente. Positivo quando `a` é maior que `b`. */
const compararVersoes = (a: string, b: string): number => {
  const partesA = a.split(".").map(Number);
  const partesB = b.split(".").map(Number);
  const casas = Math.max(partesA.length, partesB.length);

  for (let i = 0; i < casas; i++) {
    const diferenca = (partesA[i] || 0) - (partesB[i] || 0);
    if (diferenca !== 0) return diferenca;
  }
  return 0;
};

/**
 * Escolhe o documento de maior versão dentro de um tipo. `GET /legal` devolve
 * todas as versões já publicadas e sem ordenação garantida (o service da API faz
 * um `find` sem `order`), então a seleção precisa acontecer no cliente.
 *
 * selecionarUltimaVersao(documentos, "PRIVACY_POLICY") // => { version: "1.0.3", ... }
 */
export const selecionarUltimaVersao = (
  documentos: DocumentoLegal[],
  tipo: LegalTipo,
): DocumentoLegal | null => {
  const doTipo = documentos.filter((documento) => documento.type === tipo);
  if (doTipo.length === 0) return null;

  return doTipo.reduce((maior, atual) =>
    compararVersoes(atual.version, maior.version) > 0 ? atual : maior,
  );
};
